import {useState, useEffect} from 'react';
import { Link, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import './Header.css';
import withCssScope from '../withCssScope';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState("home");
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.getElementById("mobile-sidebar");
      const hamburger = event.target.closest(".hamburger-menu-btn");

      // Close sidebar if clicking outside both the sidebar and hamburger button
      if (sidebar && !sidebar.contains(event.target) && !hamburger) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMenuOpen]);

  // Scroll to section when navigating from another page
  useEffect(() => {
    if (location.pathname === "/") {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }, [location]);

  // Track scroll position and update header background to match current section
  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === "/") {
        const sections = ["home", "features", "how-it-works", "about", "contact"];
        const scrollPosition = window.scrollY + 100; // Add offset for better detection

        // Find which section is currently in view
        let activeSection = "home";

        for (const section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const { offsetTop, offsetHeight } = element;
            if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
              activeSection = section;
              break;
            }
          }
        }

        setCurrentSection(activeSection);
      }
    };

    // Run on mount and scroll
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  // Determine the header background class based on the current section
  const headerClass = `header-${currentSection}`;

  return (
    <header className={`${headerClass} text-dark py-2 fixed-top`} style={{ zIndex: 1050, top: 0 }}>
      <div id="header" className="d-flex justify-content-between align-items-center px-3">
        <div 
          className="d-flex align-items-center flex-column flex-sm-row" 
          style={{ gap: "4px" }} // Adjust the gap as needed
        >
          <img
            src="/assets/images/proRenter-Icon.png"
            alt="Prorenter Logo"
            className="img-fluid"
            style={{ height: "50px", width: "auto" }}
          />
          <div className="text-white text-center text-sm-start">
            <h3 className="mb-0" style={{ fontSize: "1.3rem", marginBottom: "2px" }}>PRORENTER</h3>
            <p className="mb-0 d-none d-sm-block" style={{ fontSize: "0.55rem", marginTop: "0px" }}>
              PROPERTY MANAGEMENT MADE EASY!
            </p>
          </div>
        </div>

        {!isMenuOpen && (
          <button
            className="hamburger-menu-btn"
            onClick={toggleMenu}
          >
            <i className="fa-solid fa-bars"></i>
          </button>
        )}

        <Sidebar isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />

        <nav className="d-none d-sm-block">
          <ul className="nav">
            <li className="nav-item">
              <Link to="/" className="nav-link text-white">Home</Link>
            </li>
            <li className="nav-item">
              <Link to="/#features" className="nav-link text-white">Features</Link>
            </li>
            <li className="nav-item">
              <Link to="/#how-it-works" className="nav-link text-white">How it works</Link>
            </li>
            <li className="nav-item">
              <Link to="/#about" className="nav-link text-white">About</Link>
            </li>
            <li className="nav-item">
              <Link to="/#contact" className="nav-link text-white">Contact</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default withCssScope(Header, 'scope-header');